export default function splitListItems<T>(items: T[], maxLength: number) {
  const firstGroup = items.slice(0, maxLength);
  const secondGroup = items.slice(maxLength, items.length);

  return [firstGroup, secondGroup];
}
